// src/utils/formsThumbnails.tsx

// ✅ этот export делает файл "модулем" и устраняет ошибку isolatedModules
export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });

export const mapBase64ToUploadList = (images: string[]) =>
  images.map((base64, i) => ({
    uid: String(i),
    name: `image-${i}`,
    status: 'done',
    url: base64,
    thumbUrl: base64,
  }));
